import { useTracking } from 'react-tracking';
import { actionToPath } from 'redux-first-router';

import { useMount } from '@simplywallst/ui-core';
import { Heading, Button } from '@simplywallst/ui-core/next';

import { ROUTE_PORTFOLIO_DEMO } from '@/constants/routes';

import { useLocation } from '@/hooks/useLocation';
import { useLegacyPortfolios } from '../../hooks/useLegacyPortfolios';

import DocumentHeader from '@/components/DocumentHeader';

import { NewLinkedPortfolio } from './components/NewLinkedPortfolio';
import { LegacyPortfolio } from './components/LegacyPortfolio';
import { NewManualPortfolio } from './components/NewManualPortfolio';
import { NewTransactionPortfolio } from './components/NewTransactionPortfolio';

export const NewPortfolio = () => {
  const { Track, trackEvent } = useTracking({ type: 'track', subject: 'page' });

  useMount(() => {
    trackEvent({ action: 'landed' });
  });

  const location = useLocation();
  const demoPath = actionToPath(
    {
      type: ROUTE_PORTFOLIO_DEMO,
      payload: {},
    },
    location.routesMap
  );

  const { keys: legacyPortfoliosKeys = [] } = useLegacyPortfolios();

  return (
    <Track>
      <DocumentHeader title="New Portfolio" />
      <section className="grid w-full max-w-screen-xl text-solid sm:gap-x4 sm:px-[2.4rem] sm:py-x4">
        <div className="flex flex-wrap items-center justify-between gap-x-x4 gap-y-x2 px-x2 py-x4 sm:p-0">
          <div className="grid gap-x1">
            <Heading size="xLarge">Create your portfolio</Heading>
            <div className="text-xs text-soft">
              Pick a creation method. Not sure which one? Check the{' '}
              <a
                href="https://support.simplywall.st/hc/en-us/articles/11096021024527-Getting-Started-with-Portfolios-and-its-Benefits"
                target="_blank"
                rel="noopener noreferrer nofollow"
              >
                Getting Started guide
              </a>
            </div>
          </div>
          <div className="flex flex-wrap gap-x-x1 gap-y-x1_5">
            <Button
              href={demoPath}
              variant="secondary"
              data-testid="view-demo-portfolio"
            >
              <span className="inline-block scale-105 pr-x0_25">🍿</span> View
              demo portfolio
            </Button>
          </div>
        </div>
        <div className="grid gap-x2 sm:grid-cols-2 sm:gap-x3">
          <section className="flex flex-col gap-x2 bg-surface-1 py-x3 sm:gap-x3 sm:rounded-lg sm:max-lg:col-span-2 lg:row-span-2">
            <NewLinkedPortfolio />
          </section>
          <section className="overflow-hidden bg-surface-1 sm:rounded-lg">
            <NewManualPortfolio />
          </section>
          <section className="overflow-hidden bg-surface-1 sm:rounded-lg">
            <NewTransactionPortfolio />
          </section>
        </div>
        {legacyPortfoliosKeys.length > 0 && (
          <div className="my-x4 flex justify-start px-x2 sm:my-x0 sm:px-x0 lg:justify-end">
            <LegacyPortfolio />
          </div>
        )}
      </section>
    </Track>
  );
};
